var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "app-main-inner",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.AssociationBusinessInformation"),
        width: "900px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", { staticStyle: { padding: "0 0 5px 0" } }, [
        _c("span", [
          _vm._v(
            " " +
              _vm._s(_vm.$t("SeaExport.BusinessNo")) +
              "：" +
              _vm._s(_vm.aData.bNo) +
              " " +
              _vm._s(_vm.$t("SeaExport.BusinessStatus")) +
              "：" +
              _vm._s(_vm.BusinessStatus) +
              " "
          )
        ])
      ]),
      _c("div", { staticStyle: { width: "800px", height: "570px" } }, [
        _c("fieldset", [
          _c("legend", [_vm._v(_vm._s(_vm.$t("SeaExport.DangerousGoods")))]),
          _c(
            "div",
            { staticStyle: { display: "flex", "flex-direction": "row" } },
            [
              _c(
                "el-form",
                {
                  staticStyle: { display: "flex", "flex-direction": "column" },
                  attrs: { "label-width": "190px", "label-position": "left" }
                },
                [
                  _c(
                    "el-form-item",
                    { staticClass: "label-none custom" },
                    [
                      _c("cargo-ag-grid", {
                        staticStyle: { width: "100%", height: "200px" },
                        attrs: {
                          "show-side-bar": false,
                          "grid-options": _vm.danger.gridOptions,
                          "column-defs": _vm.danger.columnDefs,
                          "row-data": _vm.specialGoods
                        },
                        on: {
                          gridReady: function(params) {
                            return (_vm.danger.gridApi = params.api)
                          }
                        }
                      }),
                      _c("div", { staticStyle: { width: "100%" } }, [
                        _c(
                          "div",
                          { staticStyle: { float: "right", padding: "5px" } },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  disabled: !_vm.isEditing
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SpecialGoods.Add")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "danger",
                                  disabled: !_vm.isEditing
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SpecialGoods.Delete")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  disabled: !_vm.isEditing
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SpecialGoods.Import")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  disabled: !_vm.isEditing
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SpecialGoods.FillIn")))]
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SpecialGoods.CLASSNO") } },
                    [
                      _c("el-input", {
                        attrs: { disabled: !_vm.isEditing },
                        model: {
                          value: _vm.editObj.danClassNo,
                          callback: function($$v) {
                            _vm.$set(_vm.editObj, "danClassNo", $$v)
                          },
                          expression: "editObj.danClassNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SpecialGoods.UNNO") } },
                    [
                      _c("el-input", {
                        attrs: { disabled: !_vm.isEditing },
                        model: {
                          value: _vm.editObj.danUNNo,
                          callback: function($$v) {
                            _vm.$set(_vm.editObj, "danUNNo", $$v)
                          },
                          expression: "editObj.danUNNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SpecialGoods.PACKING") } },
                    [
                      _c("el-input", {
                        attrs: { disabled: !_vm.isEditing },
                        model: {
                          value: _vm.editObj.danPacking,
                          callback: function($$v) {
                            _vm.$set(_vm.editObj, "danPacking", $$v)
                          },
                          expression: "editObj.danPacking"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.DangerousGoodsLabel") }
                    },
                    [
                      _c("el-input", {
                        attrs: { disabled: !_vm.isEditing },
                        model: {
                          value: _vm.editObj.danLable,
                          callback: function($$v) {
                            _vm.$set(_vm.editObj, "danLable", $$v)
                          },
                          expression: "editObj.danLable"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SpecialGoods.EMS") } },
                    [
                      _c("el-input", {
                        attrs: { disabled: !_vm.isEditing },
                        model: {
                          value: _vm.editObj.danEMS,
                          callback: function($$v) {
                            _vm.$set(_vm.editObj, "danEMS", $$v)
                          },
                          expression: "editObj.danEMS"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SpecialGoods.Point") } },
                    [
                      _c("el-input", {
                        attrs: { disabled: !_vm.isEditing },
                        model: {
                          value: _vm.editObj.danPoint,
                          callback: function($$v) {
                            _vm.$set(_vm.editObj, "danPoint", $$v)
                          },
                          expression: "editObj.danPoint"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.MedicalEmergencyGuideNo")
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { disabled: !_vm.isEditing },
                        model: {
                          value: _vm.editObj.danMfagNo,
                          callback: function($$v) {
                            _vm.$set(_vm.editObj, "danMfagNo", $$v)
                          },
                          expression: "editObj.danMfagNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SpecialGoods.man24") } },
                    [
                      _c("el-input", {
                        attrs: { disabled: !_vm.isEditing },
                        model: {
                          value: _vm.editObj.dan24man,
                          callback: function($$v) {
                            _vm.$set(_vm.editObj, "dan24man", $$v)
                          },
                          expression: "editObj.dan24man"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SpecialGoods.tel24") } },
                    [
                      _c("el-input", {
                        attrs: { disabled: !_vm.isEditing },
                        model: {
                          value: _vm.editObj.dan24tel,
                          callback: function($$v) {
                            _vm.$set(_vm.editObj, "dan24tel", $$v)
                          },
                          expression: "editObj.dan24tel"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "column",
                    "margin-left": "20px"
                  },
                  attrs: {
                    "label-width": "190px",
                    "label-position": "left",
                    disabled: !_vm.isEditing
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SpecialGoods.ResponsibleParty") }
                    },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.editObj.responsibleParty,
                          callback: function($$v) {
                            _vm.$set(_vm.editObj, "responsibleParty", $$v)
                          },
                          expression: "editObj.responsibleParty"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SpecialGoods.HSCODE") } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.editObj.hsCode,
                          callback: function($$v) {
                            _vm.$set(_vm.editObj, "hsCode", $$v)
                          },
                          expression: "editObj.hsCode"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SpecialGoods.PickTime") } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.editObj.danPickTime,
                          callback: function($$v) {
                            _vm.$set(_vm.editObj, "danPickTime", $$v)
                          },
                          expression: "editObj.danPickTime"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SpecialGoods.SeaPullution") } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.$t("SpecialGoods.OnlyEnterYN")
                        },
                        model: {
                          value: _vm.editObj.danSeaPullution,
                          callback: function($$v) {
                            _vm.$set(_vm.editObj, "danSeaPullution", $$v)
                          },
                          expression: "editObj.danSeaPullution"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SpecialGoods.CorrectTransportName")
                      }
                    },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.editObj.correctTransportName,
                          callback: function($$v) {
                            _vm.$set(_vm.editObj, "correctTransportName", $$v)
                          },
                          expression: "editObj.correctTransportName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SpecialGoods.SecondarySpecialGoods")
                      }
                    },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.editObj.secondarySpecialGoods,
                          callback: function($$v) {
                            _vm.$set(_vm.editObj, "secondarySpecialGoods", $$v)
                          },
                          expression: "editObj.secondarySpecialGoods"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SpecialGoods.GrossWeight") } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "190px" },
                        attrs: { min: 0, "controls-position": "right" },
                        model: {
                          value: _vm.editObj.grossWeight,
                          callback: function($$v) {
                            _vm.$set(_vm.editObj, "grossWeight", $$v)
                          },
                          expression: "editObj.grossWeight"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SpecialGoods.NeatWeight") } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "190px" },
                        attrs: { min: 0, "controls-position": "right" },
                        model: {
                          value: _vm.editObj.neatWeight,
                          callback: function($$v) {
                            _vm.$set(_vm.editObj, "neatWeight", $$v)
                          },
                          expression: "editObj.neatWeight"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SpecialGoods.OuterPackagingType")
                      }
                    },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.editObj.outerPackagingType,
                          callback: function($$v) {
                            _vm.$set(_vm.editObj, "outerPackagingType", $$v)
                          },
                          expression: "editObj.outerPackagingType"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SpecialGoods.OuterPackagingQuantity")
                      }
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "190px" },
                        attrs: { min: 0, "controls-position": "right" },
                        model: {
                          value: _vm.editObj.outerPackagingQuantity,
                          callback: function($$v) {
                            _vm.$set(_vm.editObj, "outerPackagingQuantity", $$v)
                          },
                          expression: "editObj.outerPackagingQuantity"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SpecialGoods.InnerPackagingType")
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.$t("SpecialGoods.ThisFieldRequired")
                        },
                        model: {
                          value: _vm.editObj.innerPackagingType,
                          callback: function($$v) {
                            _vm.$set(_vm.editObj, "innerPackagingType", $$v)
                          },
                          expression: "editObj.innerPackagingType"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SpecialGoods.InnerPackagingQuantity")
                      }
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "190px" },
                        attrs: { min: 0, "controls-position": "right" },
                        model: {
                          value: _vm.editObj.InnerPackagingQuantity,
                          callback: function($$v) {
                            _vm.$set(_vm.editObj, "InnerPackagingQuantity", $$v)
                          },
                          expression: "editObj.InnerPackagingQuantity"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SpecialGoods.Remark") } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea", rows: 2 },
                        model: {
                          value: _vm.editObj.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.editObj, "remark", $$v)
                          },
                          expression: "editObj.remark"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SpecialGoods.PackingCode") } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.editObj.packingCode,
                          callback: function($$v) {
                            _vm.$set(_vm.editObj, "packingCode", $$v)
                          },
                          expression: "editObj.packingCode"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _c("br"),
      _c("div", { staticStyle: { width: "810px", height: "298px" } }, [
        _c("fieldset", [
          _c("legend", [_vm._v(_vm._s(_vm.$t("SeaExport.ContainerInfo")))]),
          _c(
            "div",
            { staticStyle: { display: "flex", "flex-direction": "column" } },
            [
              _c(
                "div",
                { staticStyle: { padding: "5px 0" } },
                [
                  _c(
                    "el-button",
                    { attrs: { disabled: !_vm.isEditing, type: "primary" } },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.AddPackingInfo")))]
                  ),
                  _c(
                    "el-button",
                    { attrs: { disabled: !_vm.isEditing, type: "danger" } },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.RemovePackingInfo")))]
                  )
                ],
                1
              ),
              _c("cargo-ag-grid", {
                staticStyle: { width: "100%", height: "220px" },
                attrs: {
                  "show-side-bar": false,
                  "grid-options": _vm.box.gridOptions,
                  "column-defs": _vm.box.columnDefs,
                  "row-data": _vm.containerUsages
                },
                on: {
                  gridReady: function(params) {
                    return (_vm.box.gridApi = params.api)
                  }
                }
              })
            ],
            1
          )
        ])
      ]),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.addEventHander } },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Synchronization")))]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Close")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }